<template>
    <div class="container">
        <content-header title="Правила и сроки госпитализации"/>
        <div class="vc_row wpb_row vc_row-fluid">
            <div class="wpb_column vc_column_container vc_col-sm-3">
                <div class="wpb_wrapper">
                    <div class="wpb_single_image wpb_content_element vc_align_left">

                        <figure class="wpb_wrapper vc_figure">
                            <div class="vc_single_image-wrapper   vc_box_border_grey">
                                <img width="225" height="232"
                                     style="margin-bottom: 350px;"
                                     src="../../../src/assets/images/staticPages/pr_gspt1-e1500450055822.png"
                                     alt="">
                            </div>
                        </figure>
                    </div>
                </div>
            </div>
            <div class="wpb_column vc_column_container vc_col-sm-9">
                <div class="wpb_wrapper">
                    <div class="wpb_text_column wpb_content_element ">
                        <div class="wpb_wrapper">
                            <p><b>Порядок направления пациента для оказания специализированной медицинской помощи<br>
                                в стационарных условиях</b></p>
                            <p style="text-indent: 20px;">Основанием для направления пациента для оказания
                                специализированной медицинской помощи, за исключением высокотехнологичной медицинской
                                помощи, в стационарных условиях (далее – стационар, стационарные условия) является:</p>
                            <p>• наличие или подозрение на наличие у пациента заболевания и (или) состояния, требующего
                                оказания специализированной медицинской помощи в экстренной или неотложной форме в целях
                                диагностики и лечения;</p>
                            <p>&nbsp;<br>
                                • наличие или подозрение на наличие у пациента заболевания и (или) состояния,
                                представляющего угрозу жизни и здоровью окружающих (изоляция пациента, в том числе по
                                эпидемическим показаниям);</p>
                            <p>&nbsp;<br>
                                • риск развития осложнений при амбулаторном проведении пациенту или в дневном стационаре
                                медицинских вмешательств, связанных с диагностикой и лечением;</p>
                            <p>&nbsp;<br>
                                • наличие или подозрение на наличие у пациента заболевания и (или) состояния, требующего
                                оказания специализированной, в том числе высокотехнологичной, медицинской помощи в
                                плановой форме в целях профилактики, диагностики, лечения, реабилитации;</p>
                            <p>&nbsp;<br>
                                • отсутствие возможности оказания специализированной, в том числе высокотехнологичной,
                                медицинской помощи в условиях дневного стационара в связи с возрастом пациента (дети,
                                престарелые граждане) и инвалидностью 1 группы.</p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="vc_row wpb_row vc_row-fluid">
            <div class="wpb_column vc_column_container vc_col-sm-12">
                <div class="wpb_wrapper">
                    <div class="wpb_text_column wpb_content_element ">
                        <div class="wpb_wrapper">
                            <p style="text-align: left;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Определение наличия одного
                                или нескольких медицинских показаний для оказания специализированной медицинской помощи
                                стационарно (за исключением высокотехнологичной) осуществляется лечащим врачом
                                (врачом-специалистом), который:</p>
                            <p>оформляет направление и выписку из медицинской карты, содержащую диагноз заболевания
                                (состояния), код диагноза по МКБ-10, сведения о состоянии здоровья, проведенных
                                лабораторных и инструментальных обследованиях, рекомендации о необходимости оказания
                                специализированной медицинской помощи с указанием формы ее оказания (неотложная,
                                плановая);</p>
                            <p>&nbsp;<br>
                                направляет его на госпитализацию в медицинскую организацию Управления делами,
                                оказывающую специализированную медицинскую помощь.</p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="vc_row wpb_row vc_row-fluid">
            <div class="wpb_column vc_column_container vc_col-sm-12">
                <div class="wpb_wrapper">
                    <div class="vc_empty_space" style="height: 32px"><span class="vc_empty_space_inner"></span></div>
                </div>
            </div>
        </div>
        <div class="vc_row wpb_row vc_row-fluid">
            <div class="wpb_column vc_column_container vc_col-sm-3">
                <div class="wpb_wrapper">
                    <div class="wpb_single_image wpb_content_element vc_align_left">

                        <figure class="wpb_wrapper vc_figure">
                            <div class="vc_single_image-wrapper   vc_box_border_grey">
                                <img width="225" height="104"
                                     src="../../../src/assets/images/staticPages/pr_gspt3.png"
                                     alt="">
                            </div>
                        </figure>
                    </div>
                </div>
            </div>
            <div class="wpb_column vc_column_container vc_col-sm-9">
                <div class="wpb_wrapper">
                    <div class="wpb_text_column wpb_content_element ">
                        <div class="wpb_wrapper">
                            <p><b>Перечень документов для госпитализации в стационар:</b></p>
                            <ul>
                                <li style="margin-left: 1em;">&nbsp;направление;</li>
                                <li style="margin-left: 1em;">&nbsp;копию документа удостоверяющего личность;</li>
                                <li style="margin-left: 1em;">&nbsp;копию полиса медицинского страхования;</li>
                                <li style="margin-left: 1em;">&nbsp;выписку из медицинской карты.</li>
                            </ul>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="vc_row wpb_row vc_row-fluid">
            <div class="wpb_column vc_column_container vc_col-sm-12">
                <div class="wpb_wrapper">
                    <div class="vc_empty_space" style="height: 32px"><span class="vc_empty_space_inner"></span></div>
                </div>
            </div>
        </div>
        <div class="vc_row wpb_row vc_row-fluid">
            <div class="wpb_column vc_column_container vc_col-sm-12">
                <div class="wpb_wrapper">
                    <div class="wpb_text_column wpb_content_element ">
                        <div class="wpb_wrapper">
                            <p style="text-indent: 20px;"><b>Время ожидания плановой госпитализации</b> должно
                                составлять не более 10 дней с момента выдачи направления на госпитализацию, за
                                исключением необходимости оказания высокотехнологичной медицинской помощи в сроки,
                                установленные с использованием специализированной электронной системы; случаев
                                проведения ремонтных работ в конкретных структурных подразделениях стационара.</p>
                            <p style="text-indent: 20px;"><b>В случае отказа пациента от госпитализации</b>, при наличии
                                медицинских показаний для оказания специализированной медицинской помощи в экстренной
                                или неотложной форме, врач-специалист медицинской организации дает разъяснения пациенту
                                (законному представителю пациента) о возможных последствиях данного отказа для состояния
                                здоровья и жизни пациента с соблюдением требований, установленных законодательством
                                Российской Федерации и оформляет отказ в письменном виде.</p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";

export default {
    components: {
        ContentHeader
    },
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 225px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

hr {
    display: block;
    unicode-bidi: isolate;
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
    margin-inline-start: auto;
    margin-inline-end: auto;
    overflow: hidden;
    border-style: inset;
    border-width: 1px;
    color: #666;
    line-height: 1;
}

img {
    float: left;
    margin: 0 30px 30px 0;
}

ul {
    list-style-type: disc;
    margin-left: 300px;
}
</style>
